<template>
    <div>
        <v-toolbar class="main-header">
            <v-toolbar-title>
                <router-link class="logo-link" to="/">
                    <img v-if="$vuetify.breakpoint.xsOnly" src="../assets/dog-icon-header.png" alt="">
                    <img v-if="$vuetify.breakpoint.smAndUp" src="../assets/header-logo.png" alt="">
                </router-link>

            </v-toolbar-title>
            <v-spacer>
            </v-spacer>
            <v-spacer class="my-2">
                <form   v-if="showSearch"
                        id="search-form"
                        @submit="search"
                        method="get"
                        class="pt-5"
                >
                    <v-text-field
                            v-model="keywords"
                            class="search-field mt-2"
                            solo
                            light
                            :label="searchLabel"
                            clearable
                    ></v-text-field>
                </form>
            </v-spacer>
            <v-spacer>
            </v-spacer>
            <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
                <v-btn  to="/movies" text>Movies</v-btn>
                <v-btn to="/shows" text>TV Shows</v-btn>
            </v-toolbar-items>

            <v-btn v-if="$vuetify.breakpoint.xsOnly" icon dark @click.stop="drawer = !drawer" class="px-0 py-0">
                <v-icon>fas fa-ellipsis-v</v-icon>
            </v-btn>
        </v-toolbar>
        <v-navigation-drawer
                v-model="drawer"
                fixed
                temporary
                right
        >
            <div class="mt-4 text-center">
                <img src="../assets/header-logo.png" alt="">
            </div>
            <div class="clearfix pt-4">
                <v-list-item-group
                        v-model="group"
                        active-class="text--accent-4"
                >
                    <v-list-item to="/movies">
                        <v-list-item-title>Movies</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/shows">
                        <v-list-item-title>TV Shows</v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </div>




        </v-navigation-drawer>
    </div>
</template>

<script>

    export default {
        components: {
        },
        watch: {
            '$route' (to) {
                this.evaluateSearch(to.path)
            }
        },
        created() {
            this.evaluateSearch(location.href)
        },
        data() {
            return {
                drawer: null,
                showSearch: false,
                keywords: '',
                group: null,
                searchLabel: 'Search for Movies..',
                searchUrl: 'movies'
            }
        },
        methods: {
            evaluateSearch(url){
                this.keywords= '';
                this.showSearch = false;
                if(url.indexOf('movie') > -1){
                    this.searchLabel = 'Search for Movies..';
                    this.searchUrl = 'movies';
                    this.showSearch = true;
                }
                if(url.indexOf('show') > -1){
                    this.searchLabel = 'Search for TV Shows..';
                    this.searchUrl = 'shows';
                    this.showSearch = true;
                }
            },
            search(e) {
                e.preventDefault();
                this.$router.replace('/'+this.searchUrl+'?keywords='+this.keywords)
            }
        }
    }
</script>
<style>
    .search-field{
        margin-top: 20px;
    }
    .main-header{
        max-height: 65px;
    }
    .nav-link.router-link-active button{
        color: red;
    }
    .logo-link{
        text-decoration: none;
    }
    .maika,
    .elev{
        font-size: 28px;
        height: 33px;
        min-height: 33px;
        float:left;
    }
    .logo-link .maika,
    .logo-link .elev{
        display: none;
    }
    @media(min-width: 568px){
        .maika,
        .elev{
            display: inline-block;
        }
    }
    .logo-image{
        display: inline-block;
        float:left;
        margin-left: 5px;
    }
    .maika{
        color: #e2000d;
        margin-left: 10px;
    }
    .elev{
        color: #eaeaea;
    }
    .clearfix{
        clear: both;
    }
</style>